export const teethData = {
  upperLeftTeeth: [
    // Teeth 18 to 11
    {
      id: 18,
      name: "Upper Left Third Molar (Wisdom Tooth)",
      upperImg: '/ToothGrid/tooth-18-upper.png',
      frontImg: '/ToothGrid/tooth-18-front.png',
    },
    {
      id: 17,
      name: "Upper Left Second Molar",
      upperImg: '/ToothGrid/tooth-17-upper.png',
      frontImg: '/ToothGrid/tooth-17-front.png',
    },
    {
      id: 16,
      name: "Upper Left First Molar",
      upperImg: '/ToothGrid/tooth-16-upper.png',
      frontImg: '/ToothGrid/tooth-16-front.png',
    },
    {
      id: 15,
      name: "Upper Left Second Premolar (Bicuspid)",
      upperImg: '/ToothGrid/tooth-15-upper.png',
      frontImg: '/ToothGrid/tooth-15-front.png',
    },
    {
      id: 14,
      name: "Upper Left First Premolar (Bicuspid)",
      upperImg: '/ToothGrid/tooth-14-upper.png',
      frontImg: '/ToothGrid/tooth-14-front.png',
    },
    {
      id: 13,
      name: "Upper Left Canine (Cuspid)",
      upperImg: '/ToothGrid/tooth-13-upper.png',
      frontImg: '/ToothGrid/tooth-13-front.png',
    },
    {
      id: 12,
      name: "Upper Left Lateral Incisor",
      upperImg: '/ToothGrid/tooth-12-upper.png',
      frontImg: '/ToothGrid/tooth-12-front.png',
    },
    {
      id: 11,
      name: "Upper Left Central Incisor",
      upperImg: '/ToothGrid/tooth-11-upper.png',
      frontImg: '/ToothGrid/tooth-11-front.png',
    },
  ],
  upperRightTeeth: [
    // Teeth 21 to 28
    {
      id: 21,
      name: "Upper Right Central Incisor",
      upperImg: '/ToothGrid/tooth-21-upper.png',
      frontImg: '/ToothGrid/tooth-21-front.png',
    },
    {
      id: 22,
      name: "Upper Right Lateral Incisor",
      upperImg: '/ToothGrid/tooth-22-upper.png',
      frontImg: '/ToothGrid/tooth-22-front.png',
    },
    {
      id: 23,
      name: "Upper Right Canine (Cuspid)",
      upperImg: '/ToothGrid/tooth-23-upper.png',
      frontImg: '/ToothGrid/tooth-23-front.png',
    },
    {
      id: 24,
      name: "Upper Right First Premolar (Bicuspid)",
      upperImg: '/ToothGrid/tooth-24-upper.png',
      frontImg: '/ToothGrid/tooth-24-front.png',
    },
    {
      id: 25,
      name: "Upper Right Second Premolar (Bicuspid)",
      upperImg: '/ToothGrid/tooth-25-upper.png',
      frontImg: '/ToothGrid/tooth-25-front.png',
    },
    {
      id: 26,
      name: "Upper Right First Molar",
      upperImg: '/ToothGrid/tooth-26-upper.png',
      frontImg: '/ToothGrid/tooth-26-front.png',
    },
    {
      id: 27,
      name: "Upper Right Second Molar",
      upperImg: '/ToothGrid/tooth-27-upper.png',
      frontImg: '/ToothGrid/tooth-27-front.png',
    },
    {
      id: 28,
      name: "Upper Right Third Molar (Wisdom Tooth)",
      upperImg: '/ToothGrid/tooth-28-upper.png',
      frontImg: '/ToothGrid/tooth-28-front.png',
    },
  ],
  lowerLeftTeeth: [
    // Teeth 48 to 41
    {
      id: 48,
      name: "Lower Left Third Molar (Wisdom Tooth)",
      upperImg: '/ToothGrid/tooth-48-front.png',
      frontImg: '/ToothGrid/tooth-48-upper.png',
    },
    {
      id: 47,
      name: "Lower Left Second Molar",
      upperImg: '/ToothGrid/tooth-47-front.png',
      frontImg: '/ToothGrid/tooth-47-upper.png',
    },
    {
      id: 46,
      name: "Lower Left First Molar",
      upperImg: '/ToothGrid/tooth-46-front.png',
      frontImg: '/ToothGrid/tooth-46-upper.png',
    },
    {
      id: 45,
      name: "Lower Left Second Premolar (Bicuspid)",
      upperImg: '/ToothGrid/tooth-45-front.png',
      frontImg: '/ToothGrid/tooth-45-upper.png',
    },
    {
      id: 44,
      name: "Lower Left First Premolar (Bicuspid)",
      upperImg: '/ToothGrid/tooth-44-front.png',
      frontImg: '/ToothGrid/tooth-44-upper.png',
    },
    {
      id: 43,
      name: "Lower Left Canine (Cuspid)",
      upperImg: '/ToothGrid/tooth-43-front.png',
      frontImg: '/ToothGrid/tooth-43-upper.png',
    },
    {
      id: 42,
      name: "Lower Left Lateral Incisor",
      upperImg: '/ToothGrid/tooth-42-front.png',
      frontImg: '/ToothGrid/tooth-42-upper.png',
    },
    {
      id: 41,
      name: "Lower Left Central Incisor",
      upperImg: '/ToothGrid/tooth-41-front.png',
      frontImg: '/ToothGrid/tooth-41-upper.png',
    },
  ],
  lowerRightTeeth: [
    // Teeth 31 to 38
    {
      id: 31,
      name: "Lower Right Central Incisor",
      upperImg: '/ToothGrid/tooth-31-front.png',
      frontImg: '/ToothGrid/tooth-31-upper.png',
    },
    {
      id: 32,
      name: "Lower Right Lateral Incisor",
      upperImg: '/ToothGrid/tooth-32-front.png',
      frontImg: '/ToothGrid/tooth-32-upper.png',
    },
    {
      id: 33,
      name: "Lower Right Canine (Cuspid)",
      upperImg: '/ToothGrid/tooth-33-front.png',
      frontImg: '/ToothGrid/tooth-33-upper.png',
    },
    {
      id: 34,
      name: "Lower Right First Premolar (Bicuspid)",
      upperImg: '/ToothGrid/tooth-34-front.png',
      frontImg: '/ToothGrid/tooth-34-upper.png',
    },
    {
      id: 35,
      name: "Lower Right Second Premolar (Bicuspid)",
      upperImg: '/ToothGrid/tooth-35-front.png',
      frontImg: '/ToothGrid/tooth-35-upper.png',
    },
    {
      id: 36,
      name: "Lower Right First Molar",
      upperImg: '/ToothGrid/tooth-36-front.png',
      frontImg: '/ToothGrid/tooth-36-upper.png',
    },
    {
      id: 37,
      name: "Lower Right Second Molar",
      upperImg: '/ToothGrid/tooth-37-front.png',
      frontImg: '/ToothGrid/tooth-37-upper.png',
    },
    {
      id: 38,
      name: "Lower Right Third Molar (Wisdom Tooth)",
      upperImg: '/ToothGrid/tooth-38-front.png',
      frontImg: '/ToothGrid/tooth-38-upper.png',
    },
  ],
  // Child teeth (primary/deciduous teeth)
  childUpperLeftTeeth: [
    // Teeth 55 to 51
    {
      id: 55,
      name: "Upper Left Second Primary Molar",
      upperImg: '/ToothGrid/tooth-15-upper.png',
      frontImg: '/ToothGrid/tooth-15-front.png',
    },
    {
      id: 54,
      name: "Upper Left First Primary Molar",
      upperImg: '/ToothGrid/tooth-14-upper.png',
      frontImg: '/ToothGrid/tooth-14-front.png',
    },
    {
      id: 53,
      name: "Upper Left Primary Canine",
      upperImg: '/ToothGrid/tooth-13-upper.png',
      frontImg: '/ToothGrid/tooth-13-front.png',
    },
    {
      id: 52,
      name: "Upper Left Primary Lateral Incisor",
      upperImg: '/ToothGrid/tooth-12-upper.png',
      frontImg: '/ToothGrid/tooth-12-front.png',
    },
    {
      id: 51,
      name: "Upper Left Primary Central Incisor",
      upperImg: '/ToothGrid/tooth-11-upper.png',
      frontImg: '/ToothGrid/tooth-11-front.png',
    },
  ],
  childUpperRightTeeth: [
    // Teeth 61 to 65
    {
      id: 61,
      name: "Upper Right Primary Central Incisor",
      upperImg: '/ToothGrid/tooth-21-upper.png',
      frontImg: '/ToothGrid/tooth-21-front.png',
    },
    {
      id: 62,
      name: "Upper Right Primary Lateral Incisor",
      upperImg: '/ToothGrid/tooth-22-upper.png',
      frontImg: '/ToothGrid/tooth-22-front.png',
    },
    {
      id: 63,
      name: "Upper Right Primary Canine",
      upperImg: '/ToothGrid/tooth-23-upper.png',
      frontImg: '/ToothGrid/tooth-23-front.png',
    },
    {
      id: 64,
      name: "Upper Right First Primary Molar",
      upperImg: '/ToothGrid/tooth-24-upper.png',
      frontImg: '/ToothGrid/tooth-24-front.png',
    },
    {
      id: 65,
      name: "Upper Right Second Primary Molar",
      upperImg: '/ToothGrid/tooth-25-upper.png',
      frontImg: '/ToothGrid/tooth-25-front.png',
    },
  ],
  childLowerLeftTeeth: [
    // Teeth 85 to 81
    {
      id: 85,
      name: "Lower Left Second Primary Molar",
      upperImg: '/ToothGrid/tooth-45-front.png',
      frontImg: '/ToothGrid/tooth-45-upper.png',
    },
    {
      id: 84,
      name: "Lower Left First Primary Molar",
      upperImg: '/ToothGrid/tooth-44-front.png',
      frontImg: '/ToothGrid/tooth-44-upper.png',
    },
    {
      id: 83,
      name: "Lower Left Primary Canine",
      upperImg: '/ToothGrid/tooth-43-front.png',
      frontImg: '/ToothGrid/tooth-43-upper.png',
    },
    {
      id: 82,
      name: "Lower Left Primary Lateral Incisor",
      upperImg: '/ToothGrid/tooth-42-front.png',
      frontImg: '/ToothGrid/tooth-42-upper.png',
    },
    {
      id: 81,
      name: "Lower Left Primary Central Incisor",
      upperImg: '/ToothGrid/tooth-41-front.png',
      frontImg: '/ToothGrid/tooth-41-upper.png',
    },
  ],
  childLowerRightTeeth: [
    // Teeth 71 to 75
    {
      id: 71,
      name: "Lower Right Primary Central Incisor",
      upperImg: '/ToothGrid/tooth-31-front.png',
      frontImg: '/ToothGrid/tooth-31-upper.png',
    },
    {
      id: 72,
      name: "Lower Right Primary Lateral Incisor",
      upperImg: '/ToothGrid/tooth-32-front.png',
      frontImg: '/ToothGrid/tooth-32-upper.png',
    },
    {
      id: 73,
      name: "Lower Right Primary Canine",
      upperImg: '/ToothGrid/tooth-33-front.png',
      frontImg: '/ToothGrid/tooth-33-upper.png',
    },
    {
      id: 74,
      name: "Lower Right First Primary Molar",
      upperImg: '/ToothGrid/tooth-34-front.png',
      frontImg: '/ToothGrid/tooth-34-upper.png',
    },
    {
      id: 75,
      name: "Lower Right Second Primary Molar",
      upperImg: '/ToothGrid/tooth-35-front.png',
      frontImg: '/ToothGrid/tooth-35-upper.png',
    },
  ],
};



export const chiefComplaint1 = [
  "Stain on Teeth",
  "Pain in Upper Left Teeth",
  "Pain in Upper Right Teeth",
  "Pain in Lower Left Teeth",
  "Pain in Lower Right Teeth",
  "Cavity or Black Tooth",
  "Fractured Tooth (Front)",
  "Fractured Tooth (Back)",
  "Pus Discharge",
  "Sensitivity",
  "Food Lodgment",
  "Missing Tooth",
  "Misalignment of Teeth",
  "Trauma to Teeth/Gums",
  "Gum Bleeding or Swelling",
  "Bad Breath (Halitosis)",
  "Tooth Decay",
  "Gum Recession",
  "Loose Tooth",
  "Jaw Pain or Discomfort",
  "Teeth Grinding (Bruxism)",
  "Oral Sores or Ulcers",
  "Difficulty in Chewing or Swallowing",

]

export const visitReason1 = [
  "Scalling",
  "Follow up",
  "Filling",
  "Extraction",
  'RCO',
  'BMP',
  'Obturation',
  'Crown Cutting',
  'Surgical extraction',
  'Crown Cementation',
  'Post and core',
]


export const reasonOptions1 = [ //for appointments
  "RCT",
  "BMP",
  "Obturation",
  "Post and core",
  "Composite",
  "Crown cutting",
  "Crown cementation",
  "Follow-up",
  "Extraction",
  "Others",
];


export const timeBlocks1 = [
  "10:00 AM - 11:00 AM",
  "11:00 AM - 12:00 PM",
  "12:00 PM - 1:00 PM",
  "1:00 PM - 2:00 PM",
  "5:00 PM - 6:00 PM",
  "6:00 PM - 7:00 PM",
  "7:00 PM - 8:00 PM",
  "9:00 PM - 9:00 PM",

];

export const medicalConditions1 = [
  "Blood Pressure",
  "Pregnancy / Feeding",
  "Lung Problem",
  "Liver Disease",
  "Asthma",
  "Diabetes",
  "Thyroid",
  "Acidity / Stomach Ulcer",
  "Kidney Disease",
  "Epilepsy",
  "Arthritis",
  "Bleeding Disorder",
  "HIV/AIDS",
];

export const dentalReasons1 = [
  "Abrasion",
  "Abscess",
  "Attrition",
  "Carious",
  "Cavities",
  "Discoloration",
  "Fracture - Vertical",
  "Impacted",
  "Malalignment",
  "Missing Teeth/Tooth",
  "Mobility Grade-I",
  "Mobility Grade-II",
  "Mobility Grade-III",
  "Mobility Grade-IV",
  "Sensitivity",
  "Ulceration",


];

export const primaryDiagnosis1 = [
  "Acute irreversible pulpitis",
  "Chronic irreversible pulpitis",
  "Avulsion",
  "Chronic generalized gingivitis/pericoronitis",
  "Chronic irreversible pulpitis",
  "Condylar Fracture",
  "Body Fracture",
  "Synphysis Fracture",
  "Para Synphysis Fracture",
  "Leforte - I",
  "Leforte - II",
  "Leforte - III",
  "Zygomatic Fracture",
  "Cystic lesion",
  "Dental abscess - Periapical abscess/ Dentoalveolar abscess/ gingival abscess",
  "Dental caries (Occlusal)",
  "Dental caries (Mesial)",
  "Dental caries (Distal)",
  "Dental trauma",
  "Exfoliating mobility",
  "Laceration in upper lip",
  " Class-I Malocclusion",
  "Class-II Malocclusion",
  "Class-III Malocclusion",
  "Over Retained tooth",
  "Space infection",
  "Ulcer"

];

export const treatmentPlan1 = [
  "Apexification",
  "Apexogenesis",
  "Apicectomy",
  "Biopsy",
  "Bone-grafting",
  "Bleaching",
  "Composite filling",
  "Crown/Bridge",
  "Denture (Conventional)",
  "Denture (Implant Supported Overdenture)",
  "Denture (Tooth Supported Overdenture)",
  "Extraction",
  "FMR",
  "Frenectomy",
  "Flap Surgery",
  "Implant",
  "Laminates/Veneers",
  "Ortho Treatment (Braces/Aligners)",
  "Pulpectomy",
  "Pulpotomy",
  "RCT",
  "RPD",
  "Scaling",
  "Space Maintainers",
  "Surgical extraction"
];

export const medicineName = [
  "med 1",
  "med 2",
  "med 3",
  "med 4",  
  "med 5",
  "med 6",
  "med 7",
  "med 8",
  "med 9",
  "med 10",
];


export const clinicInfo = {
  name: "Mahalaxmi Dental Clinic & Implant Center",
  address: "Angur Bagicha Rd, Gajanan Colony, Teachers Colony, Gondia, Maharashtra 441614",
  phone: "+918080122519",
  email: "support.mdc@ricecity.in",
  website: "https://mahalaxmidentalclinic.ricecity.in/",
  logo: "/logo.png", // Path to the clinic logo image
};



